export default __webpack_public_path__ + "static/media/craon12.886b2b3a.jpg";